import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';

import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import { green, orange } from '@material-ui/core/colors';

import Base13Icon from './../../Color just logo - no background.svg';
import SMSLiveLogo from './../../smsliveLogo.png';

import Header from './Header';
import Footer from './Footer';
import RequestDemo from './RequestDemo';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(3),
  },
  answer: {
    padding: theme.spacing(2, 0, 0),
  },
  image: {
    flex: 1,
    padding: 2,
    maxWidth: 120,
    // height: 100,
    resizeMode: 'contain'
  },
  smsLiveLogo: {
    width: '75vw',
    maxWidth: 175,
    paddingTop: 20,
    marginRight: 100,
    // height: 312,
  },
  paper: {
    maxWidth: 120,
    // height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: '6px 16px',
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main,
  },
  logo: {
    width: 165,
    height: 48,
  },
  image: {
    flex: 1,
    padding: 2,
    width: 100,
    height: 100,
    resizeMode: 'contain'
  },
  paperLogo: {
    width: 102,
    height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
}));

export default function SMSLiveCaseStudy() {
  const classes = useStyles();
  const bull = <span className={classes.bullet}>•</span>;

  return (
    <React.Fragment>
      <CssBaseline />
      <Header/>

      <Container maxWidth="md" component="main" className={classes.heroContent}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:10}}
        >
        </Box>
        <Typography component="h1" style={{padding:20}} variant="h2" align="center" color="textPrimary" gutterBottom>
          Product-Led Case Study
        </Typography>

        <Card className={classes.cardCaseStudy} >
            <Box style={{padding:20}}>
            <CardContent>
              <Typography variant="h6" color="textPrimary" component="p" align="center" style={{paddingRight:0, paddingTop:20}}>
                Learn how this Product-Led company leveraged their data quickly to accelerate growth.
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" style={{paddingLeft:20, paddingTop:40, paddingRight:20}}>
                "We reached our data strategy goals with FloSQL in days <Box sx={{ fontWeight: 'bold'}} display='inline' >saving us time and money in development costs</Box> while getting us the data we needed to <Box sx={{ fontWeight: 'bold'}} display='inline' >fuel our product-led growth. </Box>
                With our continuously evolving product we can now make changes to our analytics in minutes."
              </Typography>
              <Typography variant="h5" color="textSecondary" component="p" align="right" style={{paddingRight:100, paddingTop:20}}>
                James Corr, Founder and CEO
              </Typography>
              <img align="right" className={classes.smsLiveLogo} src={SMSLiveLogo}/>
            </CardContent>
            </Box>
            <Box display="flex" style={{padding:20}}></Box>
        </Card>

      <Box display="flex" style={{padding:20}}></Box>

      <Grid container alignItems="flex-end" >
      <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end">

      <Timeline align="alternate">
        <TimelineItem>
          <TimelineOppositeContent>
            <Typography variant="body2" color="textSecondary">

            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot style={{backgroundColor:'#e66771'}}>
              <Icon className="fas fa-exclamation-circle"/>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" component="h1">
               Problem
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                SMS Live was having trouble identifying product issues since their internally built dashboards loaded too slowly and took weeks to update.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                The switch to Snowflake didn't solve the problem outright as they still waiting far too long to get the insights using custom DBT models and Python scripts.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                To reach their goals they needed to speed up their data strategy without more expensive hiring.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                They quickly scrapped their custom data pipelines for FloSQL and Redash dashboards.
              </Typography>
              <Box style={{padding:5}}></Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineOppositeContent>
            <Typography variant="body2" color="textSecondary">

            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot style={{backgroundColor:"#0284c7"}}>
              <Icon className="fas fa-link"/>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" component="h1">
                Integrate
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                In under 48 hours with the SMS Live production database copying to their Snowflake instance, FloSQL was integrated.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                They could then start building their data models fast, integrating further with other data ingestions, like Google Analytics, right through FloSQL.
              </Typography>
              <Box style={{padding:5}}></Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineOppositeContent>
            <Typography variant="body2" color="textSecondary">

            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot style={{backgroundColor:"#0284c7"}}>
              <Icon className="fa fa-exchange-alt"/>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" component="h1">
                Pipeline Design
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                With everything integrated they were ready to start building layers of data pipelines immediately.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                Setting up carefully crafted pipelines with FloSQL took only minutes.
              </Typography>
              <Box style={{padding:5}}></Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot style={{backgroundColor:"#0284c7"}}>
              <Icon className="fa fa-cubes"/>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" component="h1">
                Model Creation
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                Layering in SQL data models between multiple sources of data with FloSQL was simple using the model editing suite.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                Automatically generated dependency mappings on SQL queries saved SMS Live time and reduced data errors to ensure they had confidence in their data.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                Validations were added and assigned to each model to tackle any ongoing data quality issues to ensure the integrity of their most important business decisions.
              </Typography>
              <Box style={{padding:5}}></Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot style={{backgroundColor:"#0284c7"}}>
              <Icon className="fas fa-chart-line"/>
            </TimelineDot>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" component="h1">
                Dashboards
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                Dashboards on Base13's hosted Redash service brought the data to life and saved thousands of dollars in overpriced solutions.
              </Typography>
              <Box style={{padding:5}}></Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineOppositeContent>
            <Typography variant="body2" color="textSecondary">

            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot style={{backgroundColor:"#86C67C "}}>
              <Icon className="fas fa-check-circle"/>
            </TimelineDot>

          </TimelineSeparator>
          <TimelineContent>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" component="h1">
                Solution
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                In a matter of days instead of months SMS Live was able replicate and expand their slow moving admin dashboards.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                SMS Live resolved long standing product bugs and resolved their client issues before they even contacted them.
              </Typography>
              <Box style={{padding:5}}></Box>
              <Typography>
                This led them to spend more development time on product improvements to generate customer growth.
              </Typography>
              <Box style={{padding:5}}></Box>
            </Paper>
          </TimelineContent>
        </TimelineItem>

      </Timeline>

      </Grid>
      </Grid>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:30}}
        >
        <Paper elevation={3} className={classes.paperLogo} >
          <img className={classes.image} src={Base13Icon} />
        </Paper>
      </Box>
      <Box style={{padding:10}}></Box>
      <Card className={classes.cardCaseStudy} >
          <Box style={{padding:10}}>
          <CardContent>
            <Typography align="center" variant="h5" color="textSecondary" component="p" style={{paddingLeft:20, paddingTop:20, paddingRight:20}}>
              At Base13 Labs we believe in the integrity of both our technology and in the relationships we build with our customers.
              Our goal is to provide our customers with unrivaled state-of-the-art data products to solve their ever evolving needs.
            </Typography>
            <Typography align="center" variant="h5" color="textSecondary" component="p" style={{paddingLeft:20, paddingTop:20, paddingRight:20}}>
              Start your FloSQL free trial today.
            </Typography>
          </CardContent>
          </Box>

          <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:10}}
        >
      <Box m="auto" className={classes.button}><Button size="large" href='/SignUp/' variant="contained" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7", textTransform: 'none'}} >Try It Free</Button></Box>
          {/*<Box className={classes.button}><Button size="large" href='/RequestDemo' variant="outlined" style={{color:"#0284c7", borderColor:"#0284c7"}} >Request Demo</Button></Box>*/}
        </Box>
        <Box display="flex" style={{padding:10}}></Box>
      </Card>



      </Container>
      <Footer/>
    </React.Fragment>
  );
}